
const rootReducer = (state = {}, action) => {
    switch (action.type) {
    case 'APPLY_FILTER_GROUP_COLLECTION': {
        const { filterGroupCollection, filterGroupCollectionIndex } = action.payload;
        const filterGroupCollections = state.verticals.find(vertical =>
            Number(vertical.id) === Number(state.activeVerticalId)
        ).filterGroupCollections.map((fGroupCollection, index) => {
            if (Number(index) !== Number(filterGroupCollectionIndex)) {
                return fGroupCollection;
            }
            return {
                ...fGroupCollection,
                ...filterGroupCollection
            };
        });
        const verticals = state.verticals.map(vertical => {
            if (Number(vertical.id) !== Number(state.activeVerticalId)) {
                return vertical;
            }
            return {
                ...vertical,
                filterGroupCollections
            };
        });
        return {
            ...state,
            verticals
        };
    }
    case 'APPLY_FILTER_GROUP_COLLECTION_BY_ID': {
        const { filterGroupCollection, filterGroupCollectionId } = action.payload;
        const filterGroupCollections = state.verticals.find(vertical =>
            Number(vertical.id) === Number(state.activeVerticalId)
        ).filterGroupCollections.map(fGroupCollection => {
            if (Number(fGroupCollection.id) !== Number(filterGroupCollectionId)) {
                return fGroupCollection;
            }
            return {
                ...fGroupCollection,
                ...filterGroupCollection
            };
        });
        const verticals = state.verticals.map(vertical => {
            if (Number(vertical.id) !== Number(state.activeVerticalId)) {
                return vertical;
            }
            return {
                ...vertical,
                filterGroupCollections
            };
        });
        return {
            ...state,
            verticals
        };
    }
    case 'APPLY_FILTER_GROUP_COLLECTIONS': {
        const { filterGroupCollections } = action.payload;
        const verticals = state.verticals.map(vertical => {
            if (Number(vertical.id) !== Number(state.activeVerticalId)) {
                return vertical;
            }
            return {
                ...vertical,
                filterGroupCollections
            };
        });
        return {
            ...state,
            verticals
        };
    }
    case 'CLEAR_ALL_FILTERS': {
        return {
            ...state,
            verticals: state.verticals.map(vert => {
                if (Number(vert.id) !== Number(state.activeVerticalId)) {
                    return vert;
                }
                return {
                    ...vert,
                    filterGroupCollections: vert.filterGroupCollections.map(filterGroupCollection => {
                        return {
                            ...filterGroupCollection,
                            filterGroups: filterGroupCollection.filterGroups.map(filterGroup => {
                                return {
                                    ...filterGroup,
                                    filters: filterGroup.filters.map(filter => {
                                        if (typeof filter.data.value !== 'undefined' &&
                                        typeof filter.data.default !== 'undefined') {
                                            return {
                                                ...filter,
                                                data: {
                                                    ...filter.data,
                                                    value: filter.data.default
                                                }
                                            };
                                        } else if (filter.data.values && filter.data.defaults) {
                                            const values = filter.data.values.map(value => {
                                                let newValue;
                                                filter.data.defaults.map(def => {
                                                    if (def.slug === value.slug) {
                                                        newValue = def.value;
                                                    }
                                                });
                                                return {
                                                    ...value,
                                                    value: newValue
                                                };
                                            });
                                            return {
                                                ...filter,
                                                data: {
                                                    ...filter.data,
                                                    values
                                                }
                                            };
                                        }
                                    })
                                };
                            })
                        };
                    })
                };
            })
        };
    }
    case 'CLEAR_TAG': {
        return {
            ...state,
            searchParams: {
                ...state.searchParams,
                tag: ''
            }
        };
    }
    case 'CLOSE_NAV_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                dropdown: {
                    ...state.navigation.dropdown,
                    isVisible: false
                }
            }
        };
    }
    case 'CHANGE_VERTICAL': {
        const { verticalId } = action.payload;
        return {
            ...state,
            activeVerticalId: Number(verticalId)
        };
    }
    case 'TOGGLE_CONTENT_LOADING': {
        const { value } = action.payload;
        return {
            ...state,
            contentLoading: value
        };
    }
    case 'INITIAL_CONTENT_LOADED': {
        return {
            ...state,
            initialContentLoaded: true
        };
    }
    case 'REQUEST_TAGS': {
        return state;
    }
    case 'RECEIVE_TAGS': {
        const { tags } = action.payload;
        if (tags) {
            return {
                ...state,
                tags
            };
        }
        return state;
    }
    case 'REQUEST_TAG': {
        return state;
    }
    case 'RECEIVE_TAG': {
        const { tag } = action.payload;
        if (tag) {
            return {
                ...state,
                currentTag: tag
            };
        }
        return state;
    }
    case 'REQUEST_ADMIN_TAGS': {
        return state;
    }
    case 'RECEIVE_ADMIN_TAGS_SUCCESS': {
        const { adminTags } = action.payload;
        if (adminTags) {
            return {
                ...state,
                adminTags: [
                    ...adminTags
                ]
            };
        }
        return state;
    }
    // case 'RECEIVE_ADMIN_TAGS_FAILURE': {
    //     const { error } = action.payload;
    // }
    case 'SET_ADMIN_MODE': {
        const { modeId } = action.payload;
        if (typeof modeId !== 'undefined' && modeId !== null) {
            return {
                ...state,
                user: {
                    ...state.navigation.user,
                    adminModeId: modeId
                }
            };
        }
        return state;
    }
    case 'START_ADD_ASSET_TAG_REQUEST': {
        return state;
    }
    case 'ADD_ASSET_TAG_SUCCESS': {
        // const { tag } = action.payload;
        // if (tag) {
        //     return {
        //         ...state,
        //         adminTags: [
        //             ...state.adminTags,
        //             tag
        //         ]
        //     };
        // }
        return state;
    }
    case 'ADD_ASSET_TAG_FAILURE': {
        // const { error } = action.payload;
        return state;
    }
    case 'START_DELETE_ASSET_TAG_REQUEST': {
        return state;
    }
    case 'DELETE_ASSET_TAG_SUCCESS': {
        // const { tagId } = action.payload;
        // if (tagId) {
        //     return {
        //         ...state,
        //         adminTags: state.adminTags.filter(tag => Number(tag.id) !== Number(tagId))
        //     };
        // }
        return state;
    }
    // case 'DELETE_ASSET_TAG_FAILURE': {
    //     const { error } = action.payload;
    //     return state;
    // }
    case 'START_AGREED_TO_LIST_REQUEST': {
        return state;
    }
    case 'TOGGLE_AGREED_TO_LIST_SUCCESS': {
        const { venueId, agreedToList } = action.payload;
        if (venueId) {
            const data = state.searchResults.data.map(result => {
                if (Number(result.venue_id) !== Number(venueId)) {
                    return result;
                }

                return {
                    ...result,
                    venue_agreed_to_list: agreedToList
                };
            });
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    data
                }
            };
        }
        return state;
    }
    case 'TOGGLE_AGREED_TO_LIST_FAILURE': {
    //     const { error } = action.payload;
        return state;
    }
    case 'START_ADD_REMOVE_ROOM_VERTICAL_CHANGE_REQUEST': {
        return state;
    }
    case 'ADD_REMOVE_ROOM_VERTICAL_CHANGE_SUCCESS': {
        // const { vertical } = action.payload;
        return state;
    }
    case 'ADD_REMOVE_ROOM_VERTICAL_CHANGE_FAILURE': {
        // const { error } = action.payload;
        return state;
    }
    case 'COMMON/NAV/GET_NAVIGATION_STATE_REQUEST': {
        return state;
    }
    case 'COMMON/NAV/GET_NAVIGATION_STATE_SUCCESS': {
        const { navState } = action.payload;
        if (navState) {
            return {
                ...state,
                navigation: {
                    ...state.navigation,
                    ...navState
                }
            };
        }
        return state;
    }
    case 'COMMON/NAV/GET_USER_INFO_REQUEST': {
        return state;
    }
    case 'COMMON/NAV/GET_USER_INFO_SUCCESS': {
        const { user } = action.payload;
        if (user) {
            return {
                ...state,
                navigation: {
                    ...state.navigation,
                    user: {
                        ...state.navigation.user,
                        ...user,
                        adminModeId: 0,
                        isLoggedIn: true
                    }
                }
            };
        }
        return state;
    }
    case 'REQUEST_SEARCH_RESULTS': {
        return {
            ...state,
            awaitingResults: true
        };
    }
    case 'RECEIVE_SEARCH_RESULTS': {
        const { response } = action.payload;
        if (response) {
            return {
                ...state,
                searchObject: {
                    ...state.searchObject,
                    ...response.search
                },
                searchResults: response.results,
                awaitingResults: false
            };
        }
        return state;
    }
    case 'REQUEST_SEARCH_VERTICALS': {
        return state;
    }
    case 'RECEIVE_SEARCH_VERTICALS': {
        const { verticals } = action.payload;
        if (verticals) {
            return {
                ...state,
                verticals
            };
        }
        return state;
    }
    case 'HANDLE_PAGE_CHANGE': {
        const { pageNo } = action.payload;
        if (pageNo) {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    activePage: pageNo
                }
            };
        }
        return state;
    }
    case 'SELECT_DATE': {
        const { date } = action.payload;
        if (date) {
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    date
                }
            };
        }
        return state;
    }
    case 'SELECT_TAG': {
        const { tag } = action.payload;
        if (tag) {
            return {
                ...state,
                activeVerticalId: tag.quick_vertical_id,
                searchParams: {
                    ...state.searchParams,
                    tag: tag.quick_slug
                }
            };
        }
        return state;
    }
    case 'SELECT_GUESTS': {
        const { guests } = action.payload;
        if (guests) {
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    guests: Number(guests)
                }
            };
        }
        return state;
    }
    case 'SELECT_LOCATION': {
        const { location } = action.payload;
        if (location) {
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    location
                }
            };
        }
        return state;
    }
    case 'SET_ACTIVE_FILTER_GROUP_COLLECTION': {
        const { filterGroupCollectionIndex } = action.payload;
        if (typeof filterGroupCollectionIndex !== 'undefined') {
            return {
                ...state,
                activeFilterGroupCollectionIndex: Number(filterGroupCollectionIndex)
            };
        }
        return state;
    }
    case 'SET_ARRAY_FILTER': {
        const {
            paramSlug,
            filterIdArray
        } = action.payload;
        const activeVertical = state.verticals.find(vert =>
            vert.id === state.activeVerticalId
        );
        const filterGroupCollections = activeVertical.filterGroupCollections.map(filterGroupCollection => {
            const filterGroups = filterGroupCollection.filterGroups.map(filterGroup => {
                if (filterGroup.slug !== paramSlug) {
                    return filterGroup;
                }
                const filters = filterGroup.filters.map(filter => {
                    if (filterIdArray.indexOf(String(filter.contextId)) === -1) {
                        return filter;
                    }
                    const updatedFilter = {
                        ...filter,
                        data: {
                            ...filter.data,
                            value: true
                        }
                    };
                    return {
                        ...filter,
                        ...updatedFilter
                    };
                });
                return {
                    ...filterGroup,
                    filters
                };
            });
            return {
                ...filterGroupCollection,
                filterGroups
            };
        });
        const verticals = state.verticals.map(vert => {
            if (vert.id !== state.activeVerticalId) {
                return vert;
            }
            return {
                ...vert,
                filterGroupCollections
            };
        });
        return {
            ...state,
            verticals
        };
    }
    case 'SET_SINGULAR_FILTER': {
        const {
            paramSlug,
            filterValue
        } = action.payload;
        const activeVertical = state.verticals.find(vert =>
            vert.id === state.activeVerticalId
        );
        const filterGroupCollections = activeVertical.filterGroupCollections.map(filterGroupCollection => {
            let buttonText;
            const filterGroups = filterGroupCollection.filterGroups.map(filterGroup => {
                if (filterGroup.inputType === 'slider') {
                    const filters = filterGroup.filters.map(filter => {
                        if (filter.data.type === 'range') {
                            const updatedValuesArray = filter.data.values.map(value => {
                                if (value.slug === paramSlug) {
                                    return {
                                        ...value,
                                        value: Number(filterValue)
                                    };
                                }
                                return value;
                            });
                            const min = updatedValuesArray.find(val => val.slug === 'min_price').value;
                            const max = updatedValuesArray.find(val => val.slug === 'max_price').value;
                            buttonText = `${state.searchObject.currency_symbol_left}${min} - ${state.searchObject.currency_symbol_left}${max}`;
                            const updatedFilter = {
                                ...filter,
                                data: {
                                    ...filter.data,
                                    values: updatedValuesArray
                                }
                            };
                            return {
                                ...filter,
                                ...updatedFilter
                            };
                        }
                        return filter;
                    });
                    return {
                        ...filterGroup,
                        filters
                    };
                } else if (filterGroup.slug !== paramSlug) {
                    return filterGroup;
                } else if (filterGroup.inputType === 'increment' || filterGroup.inputType === 'dropdown') {
                    const filters = filterGroup.filters.map(filter => {
                        const updatedFilter = {
                            ...filter,
                            data: {
                                ...filter.data,
                                value: Number(filterValue)
                            }
                        };
                        return {
                            ...filter,
                            ...updatedFilter
                        };
                    });
                    return {
                        ...filterGroup,
                        filters
                    };
                } else if (filterGroup.inputType === 'toggle-switch') {
                    const filters = filterGroup.filters.map(filter => {
                        const updatedFilter = {
                            ...filter,
                            data: {
                                ...filter.data,
                                value: filterValue === 'true'
                            }
                        };
                        return {
                            ...filter,
                            ...updatedFilter
                        };
                    });
                    return {
                        ...filterGroup,
                        filters
                    };
                }
            });
            if (buttonText) {
                return {
                    ...filterGroupCollection,
                    buttonText,
                    filterGroups
                };
            }
            return {
                ...filterGroupCollection,
                filterGroups
            };
        });
        const verticals = state.verticals.map(vert => {
            if (Number(vert.id) !== Number(state.activeVerticalId)) {
                return vert;
            }
            return {
                ...vert,
                filterGroupCollections
            };
        });
        return {
            ...state,
            verticals
        };
    }
    case 'SET_TAG_LABEL': {
        const { tagLabel } = action.payload;
        return {
            ...state,
            tagLabel
        };
    }
    case 'SET_VERTICAL': {
        const { verticalId } = action.payload;
        return {
            ...state,
            activeVerticalId: Number(verticalId)
        };
    }
    case 'START_TOGGLE_ASSET_IMAGE_FLAG_REQUEST': {
        return state;
    }
    case 'TOGGLE_ASSET_IMAGE_FLAG_SUCCESS': {
        const { assetId, imageId, flagged } = action.payload;
        const data = state.searchResults.data.map(result => {
            if (Number(result.asset_id) !== Number(assetId)) {
                return result;
            }
            const images = [...result.images];
            const updatedImages = images.map(image => {
                if (Number(image.id) !== imageId) {
                    return image;
                }
                return {
                    ...image,
                    flagged
                };
            });
            return {
                ...result,
                images: updatedImages
            };
        });
        return {
            ...state,
            searchResults: {
                ...state.searchResults,
                data
            }
        };
    }
    case 'TOGGLE_ASSET_IMAGE_FLAG_FAILURE': {
        // const { error } = action.payload;
        return state;
    }
    case 'TOGGLE_FAVOURITE_SUCCESS': {
        const { assetId } = action.payload;
        const newRoom = state.searchResults.data.find(room => {
            return Number(room.asset_id) === Number(assetId);
        });
        if (Number(newRoom.room_favourite) === 0) {
            newRoom.room_favourite = 1;
        } else {
            newRoom.room_favourite = 0;
        }
        const data = state.searchResults.data.map(room => {
            if (Number(room.asset_id) !== Number(assetId)) {
                return room;
            }
            return {
                ...room,
                ...newRoom
            };
        });
        return {
            ...state,
            searchResults: {
                ...state.searchResults,
                data
            }
        };
    }
    case 'TOGGLE_FAVOURITE_FAILURE': {
        // const { error } = action.payload;
        return state;
    }
    case 'TOGGLE_FULL_SCREEN_PANEL': {
        return {
            ...state,
            fullScreenPanel: {
                ...state.fullScreenPanel,
                isVisible: !state.fullScreenPanel.isVisible
            }
        };
    }
    case 'TOGGLE_MAP_PANEL': {
        return {
            ...state,
            mapState: {
                ...state.mapState,
                mapPanelVisible: !state.mapState.mapPanelVisible
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_HELP_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                helpDropdown: {
                    ...state.navigation.helpDropdown,
                    isVisible: !state.navigation.helpDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_MOB_HELP_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                mobHelpDropdown: {
                    ...state.navigation.mobHelpDropdown,
                    isVisible: !state.navigation.mobHelpDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_VENUE_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                venueDropdown: {
                    ...state.navigation.venueDropdown,
                    isVisible: !state.navigation.venueDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_MOB_VENUE_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                mobVenueDropdown: {
                    ...state.navigation.mobVenueDropdown,
                    isVisible: !state.navigation.mobVenueDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_PERF_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                perfDropdown: {
                    ...state.navigation.perfDropdown,
                    isVisible: !state.navigation.perfDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_MOB_PERF_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                mobPerfDropdown: {
                    ...state.navigation.mobPerfDropdown,
                    isVisible: !state.navigation.mobPerfDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_INVOICE_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                invoiceDropdown: {
                    ...state.navigation.invoiceDropdown,
                    isVisible: !state.navigation.invoiceDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_MOB_INVOICE_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                mobInvoiceDropdown: {
                    ...state.navigation.mobInvoiceDropdown,
                    isVisible: !state.navigation.mobInvoiceDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_INVENT_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                inventDropdown: {
                    ...state.navigation.inventDropdown,
                    isVisible: !state.navigation.inventDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_MOB_INVENT_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                mobInventDropdown: {
                    ...state.navigation.mobInventDropdown,
                    isVisible: !state.navigation.mobInventDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_ADMINHELP_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                adminHelpDropdown: {
                    ...state.navigation.adminHelpDropdown,
                    isVisible: !state.navigation.adminHelpDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_MOB_ADMINHELP_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                mobAdminHelpDropdown: {
                    ...state.navigation.mobAdminHelpDropdown,
                    isVisible: !state.navigation.mobAdminHelpDropdown.isVisible
                }
            }
        };
    }
    case 'COMMON/NAVIGATION/TOGGLE_NAV_DROPDOWN': {
        return {
            ...state,
            navigation: {
                ...state.navigation,
                dropdown: {
                    ...state.navigation.dropdown,
                    isVisible: !state.navigation.dropdown.isVisible
                }
            }
        };
    }
    case 'SET_REQUIRES_REFIT_AND_MAP_UNSTABLE': {
        return {
            ...state,
            mapState: {
                ...state.mapState,
                requiresRefit: true,
                unstable: true
            }
        };
    }
    case 'UNSET_MAP_UNSTABLE': {
        return {
            ...state,
            mapState: {
                ...state.mapState,
                unstable: false
            }
        };
    }
    case 'UNSET_REQUIRES_REFIT': {
        return {
            ...state,
            mapState: {
                ...state.mapState,
                requiresRefit: false
            }
        };
    }
    case 'UPDATE_SLIDER_TEXT': {
        const verticals = state.verticals.map(vertical => {
            const filterGroupCollections = vertical.filterGroupCollections.map(filterGroupCollection => {
                let buttonText;
                const filterGroups = filterGroupCollection.filterGroups.map(filterGroup => {
                    const filters = filterGroup.filters.map(filter => {
                        if (filter.data.type === 'range') {
                            const min = filter.data.values.find(val => val.slug === 'min_price').value;
                            const max = filter.data.values.find(val => val.slug === 'max_price').value;
                            buttonText = `${state.searchObject.currency_symbol_left}${min} - ${state.searchObject.currency_symbol_left}${max}`;
                        }
                        return filter;
                    });
                    return {
                        ...filterGroup,
                        filters
                    };
                });
                if (buttonText) {
                    return {
                        ...filterGroupCollection,
                        buttonText,
                        filterGroups
                    };
                }
                return filterGroupCollection;
            });
            return {
                ...vertical,
                filterGroupCollections
            };
        });
        return {
            ...state,
            verticals
        };
    }
    case 'TOGGLE_AWAITING_RESULTS': {
        const { awaitingResults } = action.payload;
        return {
            ...state,
            awaitingResults
        };
    }
    case 'TOGGLE_ROOM_HOVER': {
        const { roomId } = action.payload;
        if (state.hoveredRoomId !== 0) {
            return {
                ...state,
                lastHoveredRoomId: state.hoveredRoomId,
                hoveredRoomId: Number(roomId)
            };
        }
        return {
            ...state,
            hoveredRoomId: Number(roomId)
        };
    }
    case 'TOGGLE_SEARCH_ON_MAP_MOVE': {
        return {
            ...state,
            mapState: {
                ...state.mapState,
                searchOnMapMove: !state.mapState.searchOnMapMove
            }
        };
    }
    default:
        return state;
    }
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/pages/Search/reducers/index.js